import { Component, type ReactNode } from 'react'

export default class PageErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false }
  static getDerivedStateFromError() { return { failed: true } }
  componentDidCatch() { window.dispatchEvent(new Event('b2b-render-error')) }
  render() {
    if (!this.state.failed) return this.props.children
    return <div role="alert" className="mx-auto max-w-lg p-8 text-center">
      <h1 className="text-xl font-semibold">Não foi possível abrir esta página</h1>
      <p className="my-4 text-sm text-gray-600">Confira sua conexão e tente novamente. Seu carrinho salvo estará disponível ao voltar.</p>
      <button className="button-primary" onClick={() => window.location.reload()}>Recarregar página</button>
    </div>
  }
}
